import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Ingress, H2 } from "BaseComponents/Text/";
import breakpoints from "Helpers/BreakpointHelper";
import { useGlobal } from "reactn";
import {
  BlockContainer,
  InnerBlockContainer,
  RTEWrapper,
} from "BaseComponents/Wrappers";
import { ButtonText, SubmitButton } from "BaseComponents/Button";
import styled from "styled-components";
import media from "styled-media-query";
import { useTransition, animated } from "react-spring";
import { Field } from "./components/Field";
import { FieldForm } from "./components/FormComponents";
import { post } from "Helpers/ApiHelper";

import _ from "lodash";

export const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
`;
export const Spinner = styled.div`
  background-image: url("../static/images/three-dots.svg");
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  position: absolute;
  z-index: 1;
  left: 50%;
  top: 50%;
  background-size: contain;
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ padding }) => (padding ? padding : "0 3rem")};
  align-items: center;
  ${Ingress} {
    margin-top: 20px;
  }
  ${media.lessThan(breakpoints.mobile)`

		align-items: ${({ mobileAlign }) => (mobileAlign ? mobileAlign : "flex-start")};
		padding: 0;
	`}
`;

export const ContactForm = ({
  Fields,
  Heading,
  Preamble,
  ButtonText: ContactButtonText,
  ThankYouText,
  Subject,
  FormErrorText,
  CurrentPageId,
  Recipient,
  RedirectionUrl,
  ...rest
}) => {
  const {
    handleSubmit,
    register,
    errors,
    getValues,
    setError,
    clearErrors,
    setValue,
  } = useForm({ mode: "all" });
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState(ThankYouText);
  const [toggle, set] = useState(false);
  const [theme] = useGlobal("theme");

  const transitions = useTransition(toggle, null, {
    from: {
      opacity: 0,
      width: "100%",
      transform: "translate3d(0, 100px,  0)",
    },
    enter: { opacity: 1, transform: "translate3d(0%, 0, 0)" },
    leave: {
      opacity: 0,
      position: "absolute",
      transform: "translate3d(-100%, 0, 0)",
    },
  });

  const onSubmit = (values, e) => {
    setLoading(true);
    const targetUrl = `/umbraco/api/send_email`;
    let result = Object.keys(values).map((key, i) => {
      let sendValue;
      if (typeof values[key] === "object") {
        sendValue = _.pickBy(values[key], (value, key) => {
          return value;
        });
        if (_.isEmpty(sendValue)) {
          return;
        }
        if (typeof sendValue === "boolean") {
          sendValue = sendValue ? undefined : "";
        }
        if (typeof sendValue === "object") {
          let newI = {};
          Object.keys(sendValue).map((item) => {
            if (typeof sendValue[item] === "boolean") {
              newI[item] = "";
            } else {
              newI[item] = sendValue[item];
            }
          });
          sendValue = newI;
        }
      } else if (typeof values[key] === "boolean") {
        if (values[key] === false) {
          return;
        }
        sendValue = "";
      } else {
        sendValue = values[key];
      }
      return { key: key, value: sendValue };
    });

    const labelsPosition = Fields.map((c) => c.Label);
    result = _.reject(result, _.isUndefined).sort(
      (a, b) => labelsPosition.indexOf(a.key) - labelsPosition.indexOf(b.key)
    );

    const json = {
      result: result,
      subject: Subject,
      recipient: Recipient,
    };

    post(json, targetUrl).then((res) => {
      if (!res.isSuccessStatusCode) setText(FormErrorText);

        if (RedirectionUrl != null && RedirectionUrl != undefined) {
            window.location.href = RedirectionUrl;
        }
        else {
            setLoading(false);
            set(true);
            const contactForm = document.getElementById('contactForm');

            if (contactForm != null) {
                contactForm.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }
    });
  };

  return (
    <BlockContainer className="contactForm" id="contactForm">
      <InnerBlockContainer maxWidth="712px">
        <FormWrapper>
          {loading && <Spinner />}

          {transitions.map(({ item, key, props }) =>
            !item ? (
              <animated.div key={key} style={props}>
                <Wrapper>
                  <H2>{Heading}</H2>
                  {!!Preamble && (
                    <Ingress
                      margin="0"
                      marginSmall=" 0"
                      dangerouslySetInnerHTML={{
                        __html: Preamble,
                      }}
                    ></Ingress>
                  )}
                </Wrapper>

                <FieldForm onSubmit={handleSubmit(onSubmit)}>
                  {Fields.map((field, index) => {
                    return (
                      <Field
                        key={`form-field-${index}`}
                        register={register}
                        errors={errors}
                        {...field}
                        {...rest}
                        getValues={getValues}
                        setError={setError}
                        clearErrors={clearErrors}
                        setValue={setValue}
                      />
                    );
                  })}
                  <Wrapper mobileAlign="center">
                    <SubmitButton
                      borderRadius={theme.border.radius}
                      heightsmall="48px"
                      type="submit"
                      margin="20px 0 20px 0"
                    >
                      <ButtonText heading={Heading}>{ContactButtonText}</ButtonText>
                    </SubmitButton>
                  </Wrapper>
                </FieldForm>
              </animated.div>
            ) : (
              <animated.div key={key} style={props}>
                <RTEWrapper
                  color="black"
                  dangerouslySetInnerHTML={{
                    __html: text,
                  }}
                ></RTEWrapper>
              </animated.div>
            )
          )}
        </FormWrapper>
      </InnerBlockContainer>
    </BlockContainer>
  );
};
